import * as React from 'react';
export const shieldSvg = React.forwardRef(function shieldSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm4.828 14.219 2.256 1.504a1.652 1.652 0 0 0 1.832 0l2.256-1.504a8 8 0 0 0 3.55-6.213l.249-4.478c.016-.287-.212-.53-.494-.582C12.747 2.622 9.968.936 8.919.27A1.717 1.717 0 0 0 8 0c-.326 0-.644.096-.92.271-1.048.666-3.826 2.35-5.557 2.675-.282.053-.51.295-.494.582l.25 4.478a8 8 0 0 0 3.55 6.213ZM2.776 7.923 2.57 4.226c.148-.046.296-.096.446-.15l8.197 8.197a6.5 6.5 0 0 1-.873.698l-2.256 1.504a.151.151 0 0 1-.168 0L5.66 12.97a6.5 6.5 0 0 1-2.884-5.048Zm9.4 3.193a6.498 6.498 0 0 0 1.048-3.193l.206-3.697c-.905-.28-1.867-.734-2.683-1.16a37.885 37.885 0 0 1-2.631-1.528A.22.22 0 0 0 8 1.5a.22.22 0 0 0-.116.038 37.88 37.88 0 0 1-2.631 1.528c-.24.125-.49.252-.75.377l7.674 7.673Z',
    }),
  );
});
shieldSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var shield = {
  category: 'icon',
  colorable: true,
  name: 'shield',
  svg: shieldSvg,
};
